import  { UserModule } from '@/store'

const intranetLogin = async () => {
  UserModule.intranetCheckLogin();
}

export { intranetLogin }
